export const SSG_HEAD_PROPERTY = '$unheadV3'
